import { ReactNode } from 'react';
import { StaticImageData } from 'next/image';
import { PricePeriod } from '../priceService';

export enum PaymentProvider {
  Stripe = 'stripe',
  PayPal = 'paypal',
  Mobile = 'mobile',
}

export type PaymentPlatform = 'apple' | 'google' | 'paypal' | 'card';

export interface Intents {
  clientSecret: string;
  customerId: string;
}

export type StripeSubscriptionStatus =
  | 'active'
  | 'trialing'
  | 'past_due'
  | 'incomplete'
  | 'incomplete_expired'
  | 'unpaid'
  | 'canceled';

export interface Subscriptions {
  subscriptionId: string;
  status: StripeSubscriptionStatus;
}

export enum PaymentStrategiesIds {
  Base = 'base',
  Personal = 'personal',
  Business = 'business',
}

export interface PaymentStrategy {
  id: PaymentStrategiesIds;
  title: ReactNode;
  titleIcon: StaticImageData;
  subtitle: ReactNode;
  features: { text: ReactNode; check?: boolean }[];
  customPrice?: boolean;
  period?: PricePeriod;
  exports?: number;
}

export interface SubscriptionInfo {
  subscriptionId: string;
  hasBeenCanceled: boolean;
  cancellationDate?: Date | null;
  portalSessionUrl: string;
}

export interface UpgradePreviewInfo {
  remainingAmountCents: number;
  daysLeft: number;
  isTrialing: boolean;
}

export interface PortalSession {
  url: string;
}

export type WithdrawalIneligibleReason =
  | 'not_subscribed'
  | 'not_eu'
  | 'withdrawal_period_expired';

export interface WithdrawalEligibility {
  eligible: boolean;
  reason: WithdrawalIneligibleReason | null;
  provider: 'stripe' | 'paypal';
  country: string | null;
  isEu: boolean;
  withinWithdrawalPeriod: boolean;
  daysRemaining: number;
  willRefund: boolean;
  purchaseDate: string | null;
}

export interface WithdrawalResult {
  withdrawn: boolean;
  canceled: boolean;
  refunded: boolean;
  refundedAmountCents: number;
  currency: string | null;
}
